import React, { CSSProperties, FC, useCallback, useEffect, useRef, useState } from "react";
import cls from "./customHeader.module.scss";
import {ArrowRoundedDown9x6Svg} from "../../../../svg";
import Link from "next/link";
import { IMenu } from "../../../../types/productPageTypes";
import {domainUrl} from "../../../../helper";

interface IProps {
    items: Array<IMenu>;
    openMenus: number[];
    toggleSub: (id: number) => void;
    dbName: string;
    domain: string;
}

const SUBMENU_WIDTH = 300;
const SUBMENU_VIEWPORT_GUTTER = 16;

const CustomItemList: FC<IProps> = ({ items, toggleSub, openMenus, dbName, domain }) => {
    const submenuRef = useRef<HTMLUListElement | null>(null);
    const [submenuWidth, setSubmenuWidth] = useState(SUBMENU_WIDTH);

    const updateSubmenuWidth = useCallback(() => {
        if (typeof window === "undefined" || !submenuRef.current) {
            return;
        }

        const submenuContainer = submenuRef.current.parentElement;
        if (!submenuContainer) {
            return;
        }

        const { left } = submenuContainer.getBoundingClientRect();
        const availableWidth = window.innerWidth - left - SUBMENU_VIEWPORT_GUTTER;
        const nextWidth = Math.min(SUBMENU_WIDTH, Math.max(0, Math.floor(availableWidth)));

        setSubmenuWidth(nextWidth);
    }, []);

    useEffect(() => {
        updateSubmenuWidth();

        const submenuContainer = submenuRef.current?.parentElement;
        submenuContainer?.addEventListener("mouseenter", updateSubmenuWidth);
        submenuContainer?.addEventListener("focusin", updateSubmenuWidth);
        submenuContainer?.addEventListener("click", updateSubmenuWidth);
        window.addEventListener("resize", updateSubmenuWidth);

        return () => {
            submenuContainer?.removeEventListener("mouseenter", updateSubmenuWidth);
            submenuContainer?.removeEventListener("focusin", updateSubmenuWidth);
            submenuContainer?.removeEventListener("click", updateSubmenuWidth);
            window.removeEventListener("resize", updateSubmenuWidth);
        };
    }, [updateSubmenuWidth]);

    const submenuStyle = {
        "--submenu-dynamic-width": `${submenuWidth}px`,
    } as CSSProperties;

    return (
        <ul
            ref={submenuRef}
            className={`${cls.menu__submenu}`}
            style={submenuStyle}
            onMouseEnter={updateSubmenuWidth}
            onFocus={updateSubmenuWidth}
        >
            {items.map((eachMenu, index) => {
                const { name = "", id, children = [], url_key = "", target, image } = eachMenu;
                const existThisMenuId = openMenus?.some(subId => subId === id)
                let arrow = null;
                let submenu = null;
                if (children.length) {
                    arrow = <div className={`${cls.wrapper__bttn} ${existThisMenuId && cls.closed}`}>
                        <ArrowRoundedDown9x6Svg className={cls.menu__arrow}/>
                    </div>
                    submenu = <div className={`${cls.deep__submenu} ${existThisMenuId && cls.opened__drop}`}>
                        <CustomItemList items={children} toggleSub={toggleSub} openMenus={openMenus} dbName={dbName} domain={domain}/>
                    </div>
                }

                return (
                    <li className={cls.menu__li} key={index}>
                        <div className={cls.menu_item__container} onClick={e => {
                            toggleSub(id as number);
                            e.stopPropagation()
                        }}>
                            <button className={`${cls.link__button} ${!!children.length && cls.only__link}`} >
                                <Link href={url_key} prefetch={true}>
                                    <a
                                        className={cls.menu__li__a}
                                        {...target}
                                    >
                                        <div className={cls["name-icon__container"]}>
                                            {image ? <div className={cls.icon_wrapper}>
                                                <img
                                                    width={25}
                                                    height={25}
                                                    alt="menu icon"
                                                    src={domainUrl(`${dbName}/storage/${domain}/${image}`)}
                                                    loading="lazy"
                                                />
                                            </div> : null}
                                            {name}
                                        </div>
                                    </a>
                                </Link>
                            </button>
                            {arrow}
                        </div>
                        {submenu}
                    </li>
                );
            })}
        </ul>
    );
};

export default CustomItemList;
